import { useState, useEffect } from 'react'
import useLocalStorage from '../../useLocalStorage'
import useStyles from '../../useStyles'

function useMenuState() {
    const { setAppItem, getAppItem } = useLocalStorage()
    const classes = useStyles()
    const [mobileOpen, setMobileOpen] = useState(false)
    const getMenuStateFromStorage = getAppItem('_menuOpened', "true") === "true"
    const [open, setOpen] = useState(getMenuStateFromStorage)
    useEffect(() => {
        setAppItem('_menuOpened', open)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])
    const handleDrawerToggle = (isMobile = false) => {
        if (isMobile) setMobileOpen(!mobileOpen)
        else setOpen(!open)
    }
    return { classes, mobileOpen, handleDrawerToggle, open }
}

export default useMenuState;